/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Translate_DisclaimerInputs */

const sv_google_translate_disclaimer = /** @type {(inputs: Google_Translate_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi tar inte ansvar för exakt översättningen. Den här översättningen tillhandahålls av Google.`)
};

const en_google_translate_disclaimer = /** @type {(inputs: Google_Translate_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We take no responsibility for the accuracy of the translation. This translation is provided by Google.`)
};

/**
* | output |
* | --- |
* | "We take no responsibility for the accuracy of the translation. This translation is provided by Google." |
*
* @param {Google_Translate_DisclaimerInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const google_translate_disclaimer = /** @type {((inputs?: Google_Translate_DisclaimerInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Translate_DisclaimerInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_google_translate_disclaimer(inputs)
	return en_google_translate_disclaimer(inputs)
});